import React from 'react';

const ProductCardSkeleton = () => (
  <div className="bg-white rounded-2xl overflow-hidden border border-sand shadow-card">
    {/* Image placeholder */}
    <div className="aspect-square skeleton-shimmer" />

    {/* Content placeholder */}
    <div className="p-4 space-y-3">
      {/* Duration + rating row */}
      <div className="flex justify-between items-center">
        <div className="h-5 w-16 rounded-full skeleton-shimmer" />
        <div className="h-4 w-12 rounded-full skeleton-shimmer" />
      </div>

      {/* Title lines */}
      <div className="space-y-2">
        <div className="h-4 w-full rounded skeleton-shimmer" />
        <div className="h-4 w-4/5 rounded skeleton-shimmer" />
      </div>

      {/* Price */}
      <div className="h-7 w-28 rounded skeleton-shimmer" />

      {/* Buttons */}
      <div className="flex gap-2 pt-1">
        <div className="flex-1 h-10 rounded-xl skeleton-shimmer" />
        <div className="flex-1 h-10 rounded-xl skeleton-shimmer" />
      </div>
    </div>
  </div>
);

export default ProductCardSkeleton;
